import { isDarkMode } from "./app-head-bs"

// Scrollbar width
{
    const updateScrollWidth = () => {
        document.documentElement.style.setProperty('--body-scroll-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
    };
    window.addEventListener('resize', updateScrollWidth);
    updateScrollWidth();
}

// Dark mode toggle
{
    const handleDarkModeChange = () => {
        setDarkMode(!isDarkMode());
        const isDark = isDarkMode();
        localStorage.setItem('darkMode', isDark ? '1' : '0');
    };

    const setInitialDarkMode = darkToggle => {
        darkToggle.checked = isDarkMode();
    };

    const darkModeElements = document.querySelectorAll('[data-darkmode-toggle] input, [data-darkmode-switch] input');
    darkModeElements.forEach(darkToggle => {
        darkToggle.addEventListener('change', handleDarkModeChange);
        // @ts-ignore
        setInitialDarkMode(darkToggle);
    });
}

// Horizontal Scroll
document.querySelectorAll('.uc-horizontal-scroll').forEach(element => {
    element.addEventListener('wheel', e => {
        e.preventDefault();
        // @ts-ignore
        element.scrollBy({ left: e.deltaY, behavior: 'smooth' });
    });
});

// To Top
document.addEventListener('DOMContentLoaded', () => {
    const $elem = document.querySelector('[data-uc-backtotop]');
    if (!$elem) return;

    $elem.addEventListener('click', e => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    let scrollPos = 0;
    window.addEventListener('scroll', () => {
        const top = document.body.getBoundingClientRect().top;
        // @ts-ignore
        $elem.parentNode.classList.toggle('uc-active', top <= scrollPos);
        scrollPos = top;
    });
});

// Lazy load videos
document.addEventListener("DOMContentLoaded", function() {
    let lazyVideos = [].slice.call(document.querySelectorAll("video.video-lazyload"));

    function playVideo(video) {
        let source = video.querySelector("source");
        source.src = source.dataset.src;
        video.load();
        video.muted = true; // Mute the video to allow autoplay
        if (document.visibilityState === "visible") {
            video.play(); // Start playing the video if the tab is active
        } else {
            // Add an event listener to play the video when the tab becomes active
            document.addEventListener("visibilitychange", function onVisibilityChange() {
                if (document.visibilityState === "visible") {
                    video.play();
                    document.removeEventListener("visibilitychange", onVisibilityChange);
                }
            });
        }
    }

    if ("IntersectionObserver" in window) {
        let videoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let video = entry.target;
                    playVideo(video); // Use the playVideo function
                    videoObserver.unobserve(video);
                }
            });
        });

        lazyVideos.forEach(function(video) {
            videoObserver.observe(video);
            // Check if the video is already in the viewport
            if (video.getBoundingClientRect().top < window.innerHeight && video.getBoundingClientRect().bottom > 0) {
                playVideo(video); // Use the playVideo function
                videoObserver.unobserve(video);
            }
        });
    } else {
        // Fallback for browsers that do not support IntersectionObserver
        lazyVideos.forEach(function(video) {
            playVideo(video); // Use the playVideo function
        });
    }
});
